import * as actionTypes from '../actions/actionTypes';
import produce from "immer"
import jwt_decode from "jwt-decode";
import { queryFilters } from "../initStates";

const initState = {
    currentUser: null,
    filters: {...queryFilters}
};

export default (state = initState, action) =>
    produce(state,
        draft => {
            switch (action.type) {
                case actionTypes.UPDATE_CURRENT_USER:
                    draft.currentUser = prepareUser(action.currentUser);
                    break;
                case actionTypes.CLEAR_CURRENT_USER:
                    draft.currentUser = null;
                    break;
                case actionTypes.UPDATE_CODING_EVENT_QUEUE_FILTERS:
                    draft.filters.codingEventsFilters[action.props.filterType] = action.props.filters;
                    break;
                //case actionTypes.UPDATE_CODING_EVENT_QUEUE_FILTER_PROPERTY:
                //    draft.filters.codingEventsFilters[action.filterProps.filterType][action.filterProps.propName] =
                //        action.filterProps.value;
                //    break;
                case actionTypes.RESET_CODING_EVENT_QUEUE_FILTER:
                    draft.filters.codingEventsFilters[action.filterType] =
                        initState.filters.codingEventsFilters[action.filterType];
                    break;
                default:
                    break;
            }
        });

const prepareUser = (user) => {
    let currentUser = { ...user };
    currentUser.permissions = jwt_decode(currentUser.token);
    return currentUser;
}

//export default (state, action) => {
//    state = state || applicationContextState;

//    if (action.type === actionTypes.UPDATE_CURRENT_USER) {
//        let currentUser = action.currentUser;
//        var decodedToken = jwt_decode(currentUser.token);
//        currentUser.permissions = decodedToken;

//        return {
//            ...state,
//            currentUser
//        };
//    }

//    if (action.type === actionTypes.CLEAR_CURRENT_USER) {
//        let currentUser = null;
//        return {
//            ...state,
//            currentUser
//        }
//    }

//    if (action.type === actionTypes.UPDATE_CODING_EVENT_QUEUE_FILTERS) {
//        let filters = { ...state.filters };
//        filters.codingEventQueueFilters = action.codingEventQueueFilters;
//        return {
//            ...state,
//            filters
//        }
//    }

//    return state;
//};